var path = '/app/core/services/common/modal.confirm.html';
var html = "<form ng-submit=$modal.confirm()> <div class=\"modal-header bg-{{$modal.config.flavor || 'primary'}}\"> <h3 class=modal-title>{{$modal.title}}</h3> </div> <div class=modal-body> <p>{{$modal.message}}</p> </div> <div class=\"modal-footer text-left\"> <button class=\"btn btn-default pull-left\" ng-click=$modal.cancel() type=button>Cancel</button> <button class=\"btn btn-{{$modal.config.flavor || 'primary'}} pull-right\" type=submit auto-focus>{{$modal.config.okText || 'Ok'}}</button> </div> </form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/core/services/common/modal.confirm.html
// module id = 299
// module chunks = 0